import { BACK_FIELD_BLOCKS, type BackFieldsPayload } from '../model/back-fields';
import { MGM_BACK_LABEL, MGM_BACK_PHRASE } from '../model/mgm-back-link';
import { displayMgmFabUrl } from '@/features/fab-buttons/model/mgm-fab';
import { walletValueToPreviewHtml } from '../model/wallet-markup';

interface VersoWalletPreviewProps {
  fields: BackFieldsPayload;
  visibleCount: number;
  organizationName?: string;
  /** URL do FAB MGM quando o bloco do verso está ligado. */
  mgmUrl?: string;
}

const htmlContentClass =
  'break-words whitespace-pre-wrap text-muted-foreground ' +
  '[&_a]:text-primary [&_a]:underline [&_a]:underline-offset-2';

/** Preview do verso no estilo Wallet — tokens do tema (light/dark). */
export function VersoWalletPreview({
  fields,
  visibleCount,
  organizationName,
  mgmUrl,
}: VersoWalletPreviewProps) {
  const blocks = BACK_FIELD_BLOCKS.slice(0, visibleCount).filter((block) => {
    const label = (fields[block.labelKey] ?? '').trim();
    const value = (fields[block.valueKey] ?? '').trim();
    return Boolean(label || value);
  });
  const showMgm = Boolean(mgmUrl);

  return (
    <div className="rounded-2xl border border-border/70 bg-muted/50 p-4 sm:p-5">
      <p className="mb-3 text-center text-sm font-medium text-foreground">
        {organizationName || 'Cartão Fidelidade'}
      </p>

      <div className="overflow-hidden rounded-2xl border border-border/80 bg-card text-[15px] leading-snug text-card-foreground shadow-glass-sm">
        <div className="border-b border-border/60 px-4 pb-2 pt-3">
          <p className="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
            Atualizações
          </p>
        </div>

        {blocks.length === 0 && !showMgm ? (
          <div className="px-4 py-8 text-center text-sm text-muted-foreground">
            Preencha o conteúdo de um bloco para ver o preview.
          </div>
        ) : (
          <div className="divide-y divide-border/60">
            {showMgm ? (
              <div className="space-y-1 px-4 py-3">
                <p className="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
                  {MGM_BACK_LABEL}
                </p>
                <a
                  href={mgmUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="font-medium text-primary underline underline-offset-2"
                >
                  {MGM_BACK_PHRASE}
                </a>
              </div>
            ) : null}
            {blocks.map((block) => {
              const label = fields[block.labelKey] ?? '';
              const previewHtml = walletValueToPreviewHtml(fields[block.valueKey] ?? '');
              return (
                <div key={block.id} className="space-y-1 px-4 py-3">
                  {label.trim() ? (
                    <p className="font-medium text-foreground">{label}</p>
                  ) : null}
                  {previewHtml ? (
                    <div
                      className={htmlContentClass}
                      dangerouslySetInnerHTML={{ __html: previewHtml }}
                    />
                  ) : null}
                </div>
              );
            })}
          </div>
        )}
      </div>

      <p className="mt-3 text-center text-[11px] text-muted-foreground">Preview do verso no Wallet</p>
      {showMgm && mgmUrl ? (
        <p className="mt-1 break-all text-center text-[11px] text-muted-foreground">
          Conferência do endereço: {displayMgmFabUrl(mgmUrl)}
        </p>
      ) : null}
    </div>
  );
}
